import { atomWithStorage } from "jotai/utils";
import { STORED_ATOM_KEYS } from "../constants";
import { ConfirmPaymentResponse } from "@nestcoinco/hyper-api-gateway-api-client";
import { atom } from "jotai";

interface TopupInfo extends ConfirmPaymentResponse {
  provider?: string;
  price?: number;
  isSpecialOffer?: boolean;
}

export enum PaymentStatuses {
  PENDING = "pending",
  SUCCESSFUL = "successful",
  FAILED = "failed",
}

const INITIAL_TOPUP_INFO = {
  success: false,
  amount: 0,
  isFirstTime: true,
};
export const topupInfoAtom = atomWithStorage<TopupInfo>(
  STORED_ATOM_KEYS.TOPUP_INFO,
  INITIAL_TOPUP_INFO,
  undefined,
  { getOnInit: true }
);
topupInfoAtom.debugLabel = "topup-info-atom-stored";

export const paymentStatusAtom = atom<PaymentStatuses>();
paymentStatusAtom.debugLabel = "payment-status-atom-stored";
